<template>
    <v-container>
        <loader v-if="isloading"></loader>
        <v-card shaped class="mx-md-4 my-md-4 pa-4">
            <v-row>
                <v-col cols="12">
                    <v-toolbar
                        flat
                        color="#1d2735"
                        dark
                        style="border-radius: 5px"
                    >
                        <v-icon class="white--text" style="font-size: 45px"
                            >mdi-account-supervisor-circle</v-icon
                        >
                        <pre><v-toolbar-title><h2>Crear proveedor</h2></v-toolbar-title></pre>
                    </v-toolbar>
                    <v-form class="mt-3">
                        <v-tabs :scrollable="false" v-model="tab">
                            <v-tab>Datos</v-tab>
                            <v-tab>Configuración</v-tab>
                            <v-tab v-if="proveedor.id != null">Facturas</v-tab>

                            <v-row justify="end">
                                <v-tooltip right style="margin-bottom: 5px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            fab
                                            :to="'lista-proveedores'"
                                            :loading="isloading"
                                            :disabled="isloading"
                                            color="blue"
                                            class="mt-4 mx-3"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon class="white--text"
                                                >mdi-arrow-left-bold-outline</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                    <span>Volver</span>
                                </v-tooltip>
                            </v-row>

                            <!-- Datos -->
                            <v-tab-item>
                                <v-card
                                    title="Datos de contacto"
                                    style="margin-top: 5px; padding: 10px"
                                >
                                    <v-form
                                        ref="formProveedor"
                                        v-model="validFormProveedor"
                                    >
                                        <v-row>
                                            <v-col cols="12" md="6">
                                                <v-text-field
                                                    outlined
                                                    v-model="proveedor.nombre"
                                                    label="Nombre"
                                                    required
                                                    :rules="[rules.required]"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <v-text-field
                                                    outlined
                                                    v-model="
                                                        proveedor.nombre_fiscal
                                                    "
                                                    label="Nombre fiscal"
                                                    required
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-text-field
                                                    outlined
                                                    v-model="proveedor.cif"
                                                    label="CIF"
                                                    required
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="12" md="4">
                                                <v-text-field
                                                    outlined
                                                    v-model="proveedor.email"
                                                    label="Email"
                                                    required
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-text-field
                                                    outlined
                                                    v-model="proveedor.telefono"
                                                    label="Teléfono"
                                                    required
                                                    :rules="[rules.phone_rule]"
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="12" md="8">
                                                <v-text-field
                                                    outlined
                                                    label="Dirección"
                                                    v-model="
                                                        proveedor.direccion
                                                    "
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-text-field
                                                    outlined
                                                    v-model="proveedor.cp"
                                                    label="CP"
                                                    required
                                                    :rules="[rules.number_rule]"
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="12" md="4">
                                                <v-text-field
                                                    outlined
                                                    v-model="
                                                        proveedor.poblacion
                                                    "
                                                    label="Población"
                                                    required
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-autocomplete
                                                    outlined
                                                    v-model="
                                                        proveedor.provincia
                                                    "
                                                    label="Provincia"
                                                    required
                                                    :items="provincias"
                                                    item-text="nombre"
                                                    item-value="nombre"
                                                ></v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-text-field
                                                    outlined
                                                    v-model="proveedor.pais"
                                                    label="País"
                                                    required
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="12" md="12">
                                                <v-textarea
                                                    outlined
                                                    v-model="
                                                        proveedor.observaciones
                                                    "
                                                    label="Observaciones"
                                                ></v-textarea>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-card>
                            </v-tab-item>

                            <!-- Configuración -->
                            <v-tab-item>
                                <v-card
                                    title="Datos de contacto"
                                    style="margin-top: 5px; padding: 10px"
                                >
                                    <v-row>
                                        <v-col cols="12" md="4">
                                            <div style="display: flex">
                                                <v-text-field-comma
                                                    outlined
                                                    v-model="proveedor.dcto"
                                                    type="number"
                                                    label="Descuento"
                                                >
                                                </v-text-field-comma>
                                                <v-btn-toggle
                                                    v-model="
                                                        proveedor.tipo_dcto
                                                    "
                                                    color="primary"
                                                    shaped
                                                    background-color="white"
                                                    class="ml-2"
                                                >
                                                    <v-btn text>
                                                        <v-icon
                                                            >mdi-percent</v-icon
                                                        >
                                                    </v-btn>
                                                    <v-btn text>
                                                        <v-icon
                                                            >mdi-currency-eur</v-icon
                                                        >
                                                    </v-btn>
                                                </v-btn-toggle>
                                            </div>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="4"
                                            class="d-flex justify-end"
                                        >
                                            <v-checkbox
                                                label="Enviar email de reclamaciones"
                                                v-model="proveedor.enviar_mail"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col
                                            cols="10"
                                            md="4"
                                            v-if="editaFormaPago == false"
                                        >
                                            <v-text-field-comma
                                                v-model="formaPagoActiva"
                                                readonly
                                                type="number"
                                                label="Forma de pago"
                                            ></v-text-field-comma>
                                        </v-col>
                                        <v-col
                                            cols="2"
                                            v-if="editaFormaPago == false"
                                        >
                                            <v-icon
                                                @click="editaFormaPago = true"
                                                small
                                                class="mr-2"
                                                color="#1d2735"
                                                style="font-size: 25px"
                                                title="EDITAR"
                                                >mdi-pencil-outline</v-icon
                                            >
                                        </v-col>
                                        <v-col cols="12" md="4" v-else>
                                            <dynamicSelectVue
                                                ref="dynamicSelectFormaPago"
                                                title="Forma de pago"
                                                :estados="formaspago"
                                                show="nombre"
                                                itemvalue="id"
                                                :value="proveedor.id_forma_pago"
                                                @create="saveFormaPago"
                                                @delete="deleteFormaPago"
                                                @getEstado="getFormaPagoById"
                                                @update="saveFormaPago"
                                                @changeElement="changeFormaPago"
                                            >
                                                <v-text-field
                                                    v-model="formapago.nombre"
                                                    type="text"
                                                    label="Nombre"
                                                >
                                                </v-text-field>
                                            </dynamicSelectVue>
                                        </v-col>
                                        <v-col
                                            cols="10"
                                            md="4"
                                            v-if="editBancoHabitual == false"
                                        >
                                            <v-text-field-comma
                                                v-model="bancoHabitualActivo"
                                                readonly
                                                type="number"
                                                label="Forma de pago"
                                            ></v-text-field-comma>
                                        </v-col>
                                        <v-col
                                            cols="2"
                                            v-if="editBancoHabitual == false"
                                        >
                                            <v-icon
                                                @click="
                                                    editBancoHabitual = true
                                                "
                                                small
                                                class="mr-2"
                                                color="#1d2735"
                                                style="font-size: 25px"
                                                title="EDITAR"
                                                >mdi-pencil-outline</v-icon
                                            >
                                        </v-col>
                                        <v-col cols="12" v-else md="4">
                                            <dynamicSelectVue
                                                ref="dynamicSelectFormaHabitualPago"
                                                title="Banco habitual de pago"
                                                outlined
                                                v-bind:estados="
                                                    cuentashabitualpago
                                                "
                                                show="nombre"
                                                itemvalue="id"
                                                :value="
                                                    proveedor.id_cuenta_habitual_pago
                                                "
                                                @create="saveFormaHabitualPago"
                                                @delete="
                                                    deleteFormaHabitualPago
                                                "
                                                @getEstado="
                                                    getFormaHabitualPagoById
                                                "
                                                @update="saveFormaHabitualPago"
                                                @changeElement="
                                                    changeFormaHabitualPago
                                                "
                                            >
                                                <v-text-field
                                                    v-model="
                                                        cuentahabitualpago.nombre
                                                    "
                                                    type="text"
                                                    label="Nombre"
                                                >
                                                </v-text-field>
                                            </dynamicSelectVue>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                outlined
                                                v-model="proveedor.cuenta"
                                                label="Cuenta contable"
                                                required
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                outlined
                                                v-model="proveedor.pago1"
                                                label="Días pago 1"
                                                required
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                outlined
                                                v-model="proveedor.pago2"
                                                label="Días pago 2"
                                                required
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                outlined
                                                v-model="proveedor.pago3"
                                                label="Días pago 3"
                                                required
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-tab-item>

                            <!-- Facturas -->
                            <v-tab-item v-if="proveedor.id != null">
                                <v-card>
                                    <v-card-text>
                                        <v-data-table
                                            dense
                                            @click:row="
                                                (item) => {
                                                    $router.push(
                                                        `/guardar-factura-entrante?id=${item.id}`
                                                    );
                                                }
                                            "
                                            :headers="headers"
                                            :items="facturas"
                                            :items-per-page="15"
                                            item-key="id"
                                            class="elevation-1"
                                            :sort-by="['nombre']"
                                            :sort-desc="[false]"
                                            :server-items-length="
                                                total_facturas
                                            "
                                            @options.sync="options"
                                            @update:options="onOptionsUpdate"
                                        >
                                            <template
                                                v-slot:item.fecha="{ item }"
                                            >
                                                <span v-if="item.fecha">{{
                                                    item.fecha | format_date
                                                }}</span>
                                                <span v-else style="color: red"
                                                    >No asignada</span
                                                >
                                            </template>
                                            <template
                                                v-slot:item.nro_proveedor="{
                                                    item,
                                                }"
                                            >
                                                {{
                                                    item.nro_proveedor || "—"
                                                }}
                                            </template>
                                            <template
                                                v-slot:item.fecha_vencimiento="{
                                                    item,
                                                }"
                                            >
                                                {{
                                                    item.fecha_vencimiento ||
                                                    "—"
                                                }}
                                            </template>
                                            <template
                                                v-slot:item.metodo_pago="{
                                                    item,
                                                }"
                                            >
                                                {{ item.metodo_pago || "—" }}
                                            </template>
                                            <template
                                                v-slot:item.cobrado="{ item }"
                                            >
                                                <span
                                                    :style="{
                                                        color:
                                                            item.cobrado ==
                                                            item.total
                                                                ? 'green'
                                                                : 'orange',
                                                    }"
                                                >
                                                    {{
                                                        formatPrice(
                                                            item.cobrado
                                                        )
                                                    }}€</span
                                                >
                                            </template>
                                            <template
                                                v-slot:item.abono_pendiente="{
                                                    item,
                                                }"
                                            >
                                                <span
                                                    :style="{
                                                        color:
                                                            item.abono_pendiente >
                                                            0
                                                                ? 'orange'
                                                                : 'black',
                                                    }"
                                                    >{{
                                                        formatPrice(
                                                            item.abono_pendiente
                                                        )
                                                    }}€</span
                                                >
                                            </template>
                                            <template
                                                v-slot:item.total="{ item }"
                                            >
                                                <span
                                                    >{{
                                                        formatPrice(item.total)
                                                    }}€</span
                                                >
                                            </template>
                                            <template
                                                v-slot:item.action="{ item }"
                                            >
                                                <v-btn
                                                    small
                                                    color="blue"
                                                    class="white--text"
                                                    @click.stop="
                                                        goToAbonos(item)
                                                    "
                                                >
                                                    Abonos
                                                </v-btn>
                                            </template>
                                        </v-data-table>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                        </v-tabs>

                        <v-row>
                            <v-col cols="12">
                                <router-link to="lista-proveedores">
                                    <v-btn
                                        color="blue"
                                        class="white--text mr-2"
                                    >
                                        Volver
                                    </v-btn>
                                </router-link>

                                <v-btn
                                    v-if="!proveedor.id"
                                    @click="saveproveedor"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text mr-2"
                                    >Guardar</v-btn
                                >
                                <v-btn
                                    v-if="proveedor.id"
                                    @click="updateproveedor"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text mr-2"
                                    >Actualizar</v-btn
                                >
                                <v-btn
                                    v-if="proveedor.id"
                                    @click="
                                        isDeleteProveedorDialogVisible = true
                                    "
                                    :disabled="isloading"
                                    color="red"
                                    class="white--text"
                                    >Eliminar</v-btn
                                >
                            </v-col>
                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
        </v-card>

        <DeleteDialog
            v-model="isDeleteProveedorDialogVisible"
            @delete="deleteproveedor"
        ></DeleteDialog>
    </v-container>
</template>

<script>
import dynamicSelectVue from "../../../components/general/dynamicSelect.vue";
import DeleteDialog from "../../../components/general/dialogs/DeleteDialog.vue";
import { rules } from "../../../rules";
import { formatPrice } from "../../../helpers";

export default {
    components: { dynamicSelectVue, DeleteDialog },
    data() {
        return {
            isDeleteProveedorDialogVisible: false,
            validFormProveedor: true,
            rules: rules,
            tab: 0,
            menu: false,
            proveedor: {
                id: null,
                email: "",
                telefono: "",
                direccion: "",
                enviar_mail: true,
                dcto: 0,
                tipo_dcto: 1,
                nombre_fiscal: "",
                cif: "",
                cp: "",
                poblacion: "",
                provincia: "",
                cuenta: "",
                id_forma_pago: null,
                id_cuenta_habitual_pago: null,
            },
            nueva: 0,
            cuentas: [],
            formaspago: [],
            formapago: {
                id: null,
                nombre: "",
            },
            editaFormaPago: false,
            editBancoHabitual: false,
            cuentashabitualpago: [],
            cuentahabitualpago: {
                id: null,
                nombre: "",
            },
            formaPagoActiva: "",
            bancoHabitualActivo: "",

            headers: [
                {
                    text: "Nº del sistema",
                    value: "system_number",
                    sortable: false,
                },
                { text: "Fecha de emisión", value: "fecha", sortable: false },
                {
                    text: "Nº factura proveedor",
                    value: "nro_proveedor",
                    sortable: false,
                },
                {
                    text: "Fecha(s) vencimiento",
                    value: "fecha_vencimiento",
                    sortable: false,
                },
                {
                    text: "Método de pago",
                    value: "metodo_pago",
                    sortable: false,
                },
                { text: "Nombre proveedor", value: "nombre", sortable: false },
                { text: "CIF/NIF", value: "cif", sortable: false },
                { text: "Población", value: "poblacion" },
                { text: "Total a pagar", value: "total" },
                { text: "Total pendiente", value: "abono_pendiente" },
                { text: "Total abonado", value: "cobrado" },
                { text: "Acciones", value: "action", sortable: false },
            ],
            facturas: [],
            options: {
                page: 1,
                itemsPerPage: 15,
                sortBy: ["fecha"],
                sortDesc: [false],
            },
            total_facturas: 0,
        };
    },
    watch: {
        menu(val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
        },
        proveedor() {
            if (this.proveedor.id_forma_pago != null) {
                let fp = this.formaspago.find(
                    (item) => item.id === this.proveedor.id_forma_pago
                );
                this.formaPagoActiva = fp.nombre;
                console.log("forma de pago", this.formaPagoActiva);
            } else {
                this.editaFormaPago = true;
            }
            if (this.proveedor.id_cuenta_habitual_pago != null) {
                let habitual = this.cuentashabitualpago.find(
                    (item) => item.id === this.proveedor.id_cuenta_habitual_pago
                );
                this.bancoHabitualActivo = habitual.nombre;
            } else {
                this.editBancoHabitual = true;
            }
        },
        formaspago() {
            if (this.$route.query.id) {
                this.getproveedor(this.$route.query.id);
            } else {
                this.editaFormaPago = true;
                this.editBancoHabitual = true;
            }
        },
        tab(val) {
            if (val == 2) {
                this.getFacturas();
            }
        },
        options: {
            deep: true,
            handler(val) {
                console.log("options", val);
                this.getFacturas();
            },
        },
    },
    created() {
        this.getCuentas();
        this.getFormasPago();
        this.getFormasHabitualPago();
        this.$store.dispatch("getProvincias", this);
    },
    methods: {
        changeFormaHabitualPago(item) {
            this.proveedor.id_cuenta_habitual_pago = item.id;
        },
        getFormaHabitualPagoById(id) {
            if (id != null) {
                axios
                    .get(`api/get-formahabitualpago-by-id/${id}`)
                    .then((res) => {
                        this.cuentahabitualpago = res.data.success;
                        // this.modal_serie = false
                    })
                    .catch((error) => {
                        if (error.response.code == 400) {
                            this.$custom_error(error.response.data.mensaje);
                        } else {
                            this.$custom_error("Error procesando la solicitud");
                        }
                    });
            }
        },
        deleteFormaHabitualPago(id) {
            axios
                .delete(`api/delete-formahabitualpago/${id}`)
                .then((res) => {
                    this.getFormasHabitualPago();
                    // this.modal_serie = false
                })
                .catch((error) => {
                    //console.log(error.response.status);
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Error procesando la solicitud");
                    }
                });
        },
        getFormasHabitualPago() {
            axios.get(`api/get-formashabitualpago`).then(
                (res) => {
                    this.cuentashabitualpago = res.data.success;
                },
                (res) => {}
            );
        },
        saveFormaHabitualPago() {
            axios
                .post("api/save-formahabitualpago", this.cuentahabitualpago)
                .then((res) => {
                    this.$refs.dynamicSelectFormaHabitualPago.closeDialog();
                    this.getFormasHabitualPago();
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Error procesando la solicitud");
                    }
                });
        },

        changeFormaPago(item) {
            this.proveedor.id_forma_pago = item.id;
        },
        getFormaPagoById(id) {
            if (id != null) {
                axios
                    .get(`api/get-formapago-by-id/${id}`)
                    .then((res) => {
                        this.formapago = res.data.success;
                        // this.modal_serie = false
                    })
                    .catch((error) => {
                        if (error.response.code == 400) {
                            this.$custom_error(error.response.data.mensaje);
                        } else {
                            this.$custom_error("Error procesando la solicitud");
                        }
                    });
            }
        },
        deleteFormaPago(id) {
            axios
                .delete(`api/delete-formapago/${id}`)
                .then((res) => {
                    this.getFormasPago();
                    // this.modal_serie = false
                })
                .catch((error) => {
                    //console.log(error.response.status);
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Error procesando la solicitud");
                    }
                });
        },
        getFormasPago() {
            axios.get(`api/get-formaspago`).then(
                (res) => {
                    this.formaspago = res.data.success;
                },
                (res) => {}
            );
        },
        saveFormaPago() {
            axios
                .post("api/save-formapago", this.formapago)
                .then((res) => {
                    this.getFormasPago();
                    this.$refs.dynamicSelectFormaPago.closeDialog();
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Error procesando la solicitud");
                    }
                });
        },
        getproveedor(proveedor_id) {
            axios.get(`api/getproveedor/${proveedor_id}`).then(
                (res) => {
                    this.proveedor = res.data;
                    this.proveedor.cuenta = res.data.cuenta_contable.numero;
                },
                (res) => {}
            );
        },
        updateproveedor() {
            this.$refs.formProveedor.validate();
            if (!this.validFormProveedor) return;
            axios
                .post("api/update-proveedor", this.proveedor)
                .then((res) => {
                    this.$router.push("lista-proveedores");
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        saveproveedor() {
            this.$refs.formProveedor.validate();
            if (!this.validFormProveedor) return;
            axios
                .post("api/save-proveedor", this.proveedor)
                .then((res) => {
                    this.$router.push("lista-proveedores");
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        deleteproveedor() {
            axios.post("api/delete-proveedor", { id: this.proveedor.id }).then(
                (res) => {
                    this.isDeleteProveedorDialogVisible = false;
                    this.$router.push("lista-proveedores");
                },
                (res) => {}
            );
        },
        save(date) {
            this.$refs.menu.save(date);
        },
        // Get cuentas contables
        getCuentas() {
            let prefix = 400;
            axios.get(`api/get-cuentas/${prefix}`).then(
                (res) => {
                    this.cuentas = res.data.success;

                    let numero = 0;
                    this.cuentas.forEach((element) => {
                        if (numero < element.numero) {
                            numero = element.numero;
                        }
                    });

                    this.proveedor.cuenta = parseInt(numero) + 1;
                },
                (res) => {}
            );
        },

        getFacturas() {
            axios
                .get(`api/get-facturas-entrantes`, {
                    params: {
                        page: this.options.page,
                        amount: this.options.itemsPerPage,
                        id_proveedor: this.proveedor.id,
                    },
                })
                .then(
                    (res) => {
                        this.facturas = res.data.data;
                        this.total_facturas = res.data.total;
                    },
                    (err) => {
                        this.$custom_error("Error consultando las facturas");
                    }
                );
        },
        onOptionsUpdate(newOptions) {
            this.options = newOptions;
            this.getFacturas();
        },
        goToAbonos(item) {
            this.$router.push({
                path: `/lista-abonos-entrantes?id=${item.id}`,
            });
        },
        formatPrice,
    },
    filters: {},
    computed: {
        isloading() {
            return this.$store.getters.getloading;
        },
        roles() {
            return this.$store.getters.getroles;
        },
        provincias() {
            return this.$store.getters.getprovincias;
        },
    },
};
</script>
